"use client";

import { useEffect, useState } from "react";
import {
  JTBD_HERO_FADE_MS,
  JTBD_HERO_INTERVAL_MS,
  type JtbdHeroImageCrop,
} from "./jtbdHeroMedia";

/** Same stacked-opacity slideshow as the main dashboard Headshots / Avatars heroes. */
export default function HeroCrossfade({
  images,
  alt = "",
  imageCrop = "cover",
  imageClassName,
  priority = false,
}: {
  images: string[];
  alt?: string;
  imageCrop?: JtbdHeroImageCrop;
  /** Overrides crop classes — use for wide banners that are not 16/10 cards. */
  imageClassName?: string;
  priority?: boolean;
}) {
  const frames = images.filter(Boolean);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (frames.length <= 1) return;
    const interval = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % frames.length);
    }, JTBD_HERO_INTERVAL_MS);
    return () => window.clearInterval(interval);
  }, [frames.length]);

  if (frames.length === 0) return null;

  const cropClass =
    imageClassName ??
    (imageCrop === "fill-width"
      ? "left-0 top-[-10%] h-auto w-full max-w-none"
      : "inset-0 h-full w-full object-cover object-top");

  return (
    <>
      {frames.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={i === 0 ? alt : ""}
          className={`absolute ${cropClass}`}
          style={{
            opacity: i === index ? 1 : 0,
            transition: `opacity ${JTBD_HERO_FADE_MS}ms ease-in-out`,
          }}
          loading={i === 0 && priority ? "eager" : i === 0 ? "eager" : "lazy"}
          decoding="async"
          draggable={false}
          aria-hidden={i !== 0}
        />
      ))}
    </>
  );
}
